import { createSlice } from "@reduxjs/toolkit";
const deliveryCitySlice = createSlice({
    name:'deliveryCity',
    initialState : [],
    reducers: {
        addInitialItems: (state, action) => {
            return action.payload;
        }
    }
});
export const deliveryCityactions = deliveryCitySlice.actions;
export default deliveryCitySlice;